export default __webpack_public_path__ + "static/project-slide-2-992-765-a44ab3c0827aa6c8e15fff5c78112ca9.jpg";